<template>
    <div class="w-100">
        <app-loader :loading="getLoaderStatus" :color="optionsLoader.color" :size="optionsLoader.size"></app-loader>
        <div v-if="!getLoaderStatus" class="columns" id="table">
            <div class="field is-horizontal" v-if="isMobile && searchResults.data.length">
                <div class="field-label is-normal">
                    <label class="label">Sort By <input id="sortOrder" type="checkbox" v-model="sortOrder" class="switch is-rounded" checked="checked">
                        <label for="sortOrder">Desc</label></label>
                </div>
                <div class="field-body">
                    <div class="field">
                        <div class="control">
                            <div class="sort-select select is-fullwidth">
                                <select v-model="selectedSort" v-on:change="sortAuction()">
                                    <option v-for="sortBy in getSortBy" :value="sortBy.name">{{ sortBy.text }}</option>
                                </select>
                                <div class="advance-dropdown"><i class="fa fa-angle-down"></i></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <advance-stock-car-mobile
                    v-if="isMobile"
                    v-for="(lot, index) in searchResults.data"
                    :lot="lot"
                    :user="searchResults.user"
                    :index="index"
                    v-bind:key="index">

            </advance-stock-car-mobile>
            <!--<advance-search-result-mobile
                v-if="isMobile"
                v-for="(lot, index) in searchResults"
                :lot="lot"
                :index="index"
                v-bind:key="index">
            </advance-search-result-mobile>-->
            <div  v-if="!isMobile" class="column">
                <div class="theme-table-container table-container center-column">
                    <table class="buy-now-table auction-table theme-table table is-striped is-narrow is-hoverable is-scrollable is-fullwidth" id="table">
                        <thead>
                        <tr class="top-header" id="resultTable">
                            <th></th>
                            <th @click=" orderBy('auct_date')"><span class="link">Date</span></th>
                            <th @click=" orderBy('auct_name')"><span class="link">Place</span></th>
                            <th @click=" orderBy('model_name')"><span class="link">Model</span></th>
                            <th></th>
                            <th @click=" orderBy('body')"><span class="link">Chassis</span></th>
                            <th @click=" orderBy('mileage')"><span class="link">Mileage</span></th>
                            <th @click=" orderBy('colour')"><span class="link">Color</span></th>
                            <th></th>
                            <th></th>

                        </tr>
                        <tr class="bottom-header">
                            <th>Photo</th>
                            <th>Time</th>
                            <th @click=" orderBy('lot_num')"><span class="link">Lot No</span></th>
                            <th @click=" orderBy('grade')"><span class="link">Grade</span></th>
                            <th @click=" orderBy('year')"><span class="link">Year</span></th>
                            <th @click=" orderBy('Vcc')"><span class="link">Engine Size</span></th>
                            <th @click=" orderBy('transmission')"><span class="link">Transmission</span></th>
                            <th @click=" orderBy('rate')"><span class="link">Score</span></th>
                            <th @click=" orderBy('price_start')"><span class="link">Price</span></th>
                            <th>Action</th>
                        </tr>
                        </thead>
                        <tbody>
                        <stock-cars-table-row v-for="(lot, index) in searchResults.data" :lot="lot" :user="searchResults.user" :index="index" v-bind:key="index"></stock-cars-table-row>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div class="columns" v-if="hasLots">
            <div class="column has-text-centered">
                <nav class="pagination is-centered" role="navigation" aria-label="pagination">
                    <ul class="pagination-list">
                        <li><a class="pagination-link" v-if="getCurrentPage > 2" @click="changePage(getFirstPage)">{{ getFirstPage }}</a></li>
                        <li><span class="pagination-ellipsis" v-if="getCurrentPage > 2">&hellip;</span></li>
                        <li><a class="pagination-link" v-if="getCurrentPage > 1" @click="changePage(getCurrentPage - 1)">{{ getCurrentPage - 1 }}</a></li>
                        <li><a class="pagination-link is-current" @click="changePage(getCurrentPage)">{{ getCurrentPage }}</a></li>
                        <li><a class="pagination-link" v-if="getCurrentPage < getLastPage"  @click="changePage(getCurrentPage + 1)">{{ getCurrentPage + 1 }}</a></li>
                        <li><span class="pagination-ellipsis" v-if="getCurrentPage + 1 < getLastPage">&hellip;</span></li>
                        <li><a class="pagination-link" @click="changePage(getLastPage)" v-if="getCurrentPage + 1 < getLastPage">{{ getLastPage }}</a></li>
                    </ul>
                </nav>
            </div>
        </div>
       <!-- <bid-modal v-if="biddingModalActive"></bid-modal>
        <gallery :isOpen="isOpen" :items="items" :options="options" @close="closeGallery"></gallery>-->
        <!--<market-price></market-price>-->
        <enquiry-modal :user="searchResults.user" v-if="isEnquiryActive"></enquiry-modal>
        <gallery :isOpen="isOpen" :items="items" :options="options" @close="closeGallery"></gallery>
    </div>
</template>

<script>
    //import AdvanceResultTableRow from './AdvanceResultTableRow.vue'
    //import BidModal from './../BiddingModal/BidModal'
    import StockCarsTableRow from "./StockCarsTableRow";
    import EnquiryModal from "./EnquiryModal";
    import AdvanceStockCarMobile from "./AdvanceStockCarMobile";
    import appLoader from 'vue-spinner/src/ClipLoader'
    import Gallery from '../Auctions/Advance/Result/Gallery'
    export default {
        components: {
            AdvanceStockCarMobile,
            EnquiryModal,
            //AdvanceSearchResultMobile,
            StockCarsTableRow,
            Gallery,
            appLoader,
            //MarketPrice
        },
        data() {
            return {
                optionsLoader: this.$store.getters.getOptions,
                getSortBy:[
                    { name: 'auct_date', text: 'Date'},
                    { name: 'auct_name', text: 'Place'},
                    { name: 'model_name', text: 'Model'},
                    { name: 'body', text: 'Chassis'},
                    { name: 'mileage', text: 'Mileage'},
                    { name: 'colour', text: 'Color'},
                    { name: 'lot_num', text: 'Lot No'},
                    { name: 'grade', text: 'Grade'},
                    { name: 'year', text: 'Year'},
                    { name: 'transmission', text: 'Transmission'},
                    { name: 'Vcc', text: 'Engine Size'},
                    { name: 'rate', text: 'Score'},
                    { name: 'price_start', text: 'Start/Price'},
                ]
            }
        },
        computed: {
            selectedSort:{
                get(){
                    return this.$store.getters.getStockOrderColumn
                },
                set(value){
                    this.$store.dispatch('setStockOrderColumn', value)
                    this.$store.dispatch('fetchStockCars')
                }
            },
            sortOrder: {
                get(){
                    return this.$store.getters.getStockOrderType == 'DESC' ? true : false
                },
                set(value){
                    if(value){
                        this.$store.dispatch('setStockOrderType', 'DESC')
                    }else{
                        this.$store.dispatch('setStockOrderType', 'ASC')
                    }
                    this.$store.dispatch('fetchStockCars')
                }
            },
            sortAuction(){
                this.$store.getters.getStockOrderType === 'ASC' ? this.$store.dispatch('setStockOrderType', 'DESC') : this.$store.dispatch('setStockOrderType', 'ASC')
                this.$store.dispatch('setStockOrderColumn', column)
                this.$store.dispatch('fetchStockCars')
            },
            searchResults() {
                return this.$store.getters.getStockCars
            }
            ,
            getLoaderStatus() {
                return this.$store.getters.getLoaderStatus
            },
            isLastPage() {
                return this.$store.getters.isStockCarsLastPage
            },
            getCurrentPage() {
                return this.$store.getters.getStockCarsCurrentPage
            },
            getFirstPage() {
                return this.$store.getters.getStockCarsFirstPage
            },
            getLastPage() {
                return this.$store.getters.getStockCarsLastPage
            },
            hasLots() {
                return this.$store.getters.getStockCars.data !== undefined ? this.$store.getters.getStockCars.data.length > 0 : false
            },
            biddingModalActive() {
                return this.$store.getters.getResultActiveBiddingModalStatus
            },
            isOpen() {
                return this.$store.getters.getResultGalleryStatus
            },
            items() {
                return this.$store.getters.getResultGalleryItems
            },
            car() {
                return this.$store.getters.getResultGalleryCar
            },
            options() {
                return this.$store.getters.getResultGalleryOptions
            },
            isMobile() {
                return document.documentElement.clientWidth < 450;
            },
            isEnquiryActive() {
                return this.$store.getters.getStockCarAlertModalStatus
            }
        },
        methods: {
            orderBy(column){
                this.$store.getters.getStockCarsOrderType === 'ASC' ? this.$store.dispatch('setStockCarsNewOrderType', 'DESC') : this.$store.dispatch('setStockCarsNewOrderType', 'ASC')
                this.$store.dispatch('setStockCarsNewOrderColumn', column)
                this.$store.dispatch('fetchStockCars')
            },
            closeGallery() {
                this.$store.dispatch('setResultGalleryStatus', false)
            },
            changePage(page) {
                let table = document.getElementById("table");
                //table.scrollIntoView();
                //this.$store.dispatch('loadStockCardMoreResults', page)
                this.$router.push({path: 'buy-now', query: {page: page}})
            },
        },
        created() {
            if(this.$route.query.page !== undefined){
                this.$store.dispatch('loadStockCardMoreResults', this.$route.query.page)
            }else{
                this.$store.dispatch('fetchStockCars')
            }
        },
        watch: {
            '$route'(to, from) {
                if(to.query.action != 'search'){
                    this.$store.dispatch('loadStockCardMoreResults', to.query.page)
                }
            }
        }

    }
</script>

<style scoped>
    th {
        font-size: 10px;
    }
    .top-header th {
        border-bottom: none;
        background-color: whitesmoke;
    }
    .bottom-header th {
        border-top: none;
        background-color: whitesmoke;
    }
    .link:hover {
       cursor: pointer;
    }
    .link {
        border-bottom: 1px solid blue;
        cursor: pointer;
    }

    table {
        border-collapse: collapse;
        margin: 0;
        padding: 0;
    }

    @media only screen and (max-width: 600px) {
        .columns {
            padding: 2px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/StockCars/StockCarsList.vue